import { apiPost, NoDataResponse } from "fetchApi";

interface IUnsubscribe {
    encoded_email: string;
    token: string;
}

export const unsubscribeFromNewsMailList = async (data: IUnsubscribe): Promise<NoDataResponse> => {
    return apiPost<IUnsubscribe>("/news/unsubscribe/", data);
};